import React from 'react';
import { connect } from 'react-redux';

import useCollectionState from '@src/components/common/collectionParams/useCollectionState';
import withLocalize, { IWithLocalizeOwnProps } from '@src/components/common/localize/withLocalize';
import CoordinatorExternalEducationTemplateListView from '@src/components/externaleducation/CoordinatorExternalEducationTemplateListView';
import { IExternalEducationTemplate } from '@src/model/externalEducationTemplate/ExternalEducationTemplate';
import { ICollectionData, ICollectionFetchPayload } from '@src/service/business/common/types';
import ExternalEducationTemplateListBusinessStore, { IExternalEducationTemplateListFilter } from '@src/service/business/externaleducations/ExternalEducationTemplateListBusinessStore';

// -- Const
// ----------
const VIEW_NAME = '@@EXTERNAL_EDUCATION_TEMPLATE_LIST';

// -- Prop types
// ----------
export interface IExternalEducationTemplateListContainerOwnProps {
  userId: string;
}

export interface IExternalEducationTemplateListContainerStateProps {
  externalEducationTemplateList: ICollectionData<IExternalEducationTemplate>;
}

export interface IExternalEducationTemplateListContainerDispatchProps {
  fetchList: (params: ICollectionFetchPayload<IExternalEducationTemplateListFilter>) => any;
  clearList: () => void;
}
type IExternalEducationTemplateListContainerProps = IExternalEducationTemplateListContainerOwnProps & IExternalEducationTemplateListContainerStateProps & IExternalEducationTemplateListContainerDispatchProps & IWithLocalizeOwnProps;

// -- Component
// ----------
const ExternalEducationTemplateListContainer = (props: IExternalEducationTemplateListContainerProps) => {
  const initialCollectionValues: Partial<ICollectionFetchPayload<IExternalEducationTemplateListFilter>> = { filter: { evaluator: { id: props.userId } }, sort: ['submittedAt,desc'] };
  const [collectionParams, updateCollectionParams] = useCollectionState<IExternalEducationTemplateListFilter>({
    initialValues: initialCollectionValues,
    viewName: VIEW_NAME,
    updateFn: props.fetchList,
  });

  return (
    <React.Fragment>
      {props.externalEducationTemplateList &&
        <CoordinatorExternalEducationTemplateListView
          externalEducationTemplateList={props.externalEducationTemplateList}
          externalEducationTemplateFilter={collectionParams.filter}
          onPageChange={updateCollectionParams.onPageChange}
        />
      }
    </React.Fragment>
  );

};
// -- HOCs and exports
// ----------
// `state` parameter needs a type annotation to type-check the correct shape of a state object but also it'll be used by "type inference" to infer the type of returned props
const mapStateToProps = (state: any, ownProps: IExternalEducationTemplateListContainerOwnProps): IExternalEducationTemplateListContainerStateProps => ({
  externalEducationTemplateList: ExternalEducationTemplateListBusinessStore.selectors.getExternalEducationTemplateList(state),
});

// `dispatch` parameter needs a type annotation to type-check the correct shape of an action object when using dispatch function
const mapDispatchToProps = (dispatch: any): IExternalEducationTemplateListContainerDispatchProps => ({
  fetchList: (params: ICollectionFetchPayload<IExternalEducationTemplateListFilter>) => dispatch(ExternalEducationTemplateListBusinessStore.actions.fetchExternalEducationTemplateList(params)),
  clearList: () => dispatch(ExternalEducationTemplateListBusinessStore.actions.clearExternalEducationTemplateList()),
});

export default connect<IExternalEducationTemplateListContainerStateProps, IExternalEducationTemplateListContainerDispatchProps, IExternalEducationTemplateListContainerOwnProps>(mapStateToProps, mapDispatchToProps)(withLocalize(ExternalEducationTemplateListContainer as any));
